// src/range-requester.ts
var RangeRequester = class {
  constructor(url) {
    this.url = url;
    this.reset();
  }
  getByteLength() {
    return this.byteLength;
  }
  async getUint8(offset) {
    await this.requestRange(offset, 1);
    return this.dataView.getUint8(offset - this.offset);
  }
  async getUint16(offset) {
    await this.requestRange(offset, 2);
    return this.dataView.getUint16(offset - this.offset);
  }
  async getInt32(offset) {
    await this.requestRange(offset, 4);
    return this.dataView.getInt32(offset - this.offset);
  }
  getInt32sync(offset) {
    this.ensureRange(offset, 4);
    return this.dataView.getInt32(offset - this.offset);
  }
  async getUint32(offset) {
    await this.requestRange(offset, 4);
    return this.dataView.getUint32(offset - this.offset);
  }
  getUint32sync(offset) {
    this.ensureRange(offset, 4);
    return this.dataView.getUint32(offset - this.offset);
  }
  ensureRange(offset, length, raise = true) {
    if (this.dataView && offset >= this.offset && this.offset + this.data.byteLength >= offset + length) {
      return true;
    } else if (raise) {
      throw "Data not fetched. This is an implementation error";
    }
    return false;
  }
  async getUint64(offset) {
    await this.requestRange(offset, 8);
    const msdw = this.dataView.getUint32(offset);
    const lsdw = this.dataView.getUint32(offset + 4);
    const qw = 2 ** 32 * msdw + lsdw;
    if (!Number.isSafeInteger(qw)) {
      console.warn(qw, "exceeds MAX_SAFE_INTEGER. Precision may be lost.");
    }
    return qw;
  }
  async getUint8Array(offset, length) {
    await this.requestRange(offset, length);
    return new Uint8Array(this.data, offset - this.offset, length);
  }
  async getString(offset, length) {
    return String.fromCharCode.apply(null, await this.getUint8Array(offset, length));
  }
  async requestRange(offset, length) {
    const MIN_CHUNK = 512 * 1024;
    if (this.ensureRange(offset, length, false)) {
      return;
    }
    const begin = offset < MIN_CHUNK ? 0 : offset;
    const end = Math.min(Math.max(offset + length, begin + MIN_CHUNK), this.byteLength) - 1;
    const request = await fetch(this.url, {
      headers: {
        Range: "bytes=" + begin + "-" + end
      }
    });
    this.data = await request.arrayBuffer();
    this.dataView = new DataView(this.data);
    if (request.status === 200) {
      this.offset = 0;
      this.byteLength = this.data.byteLength;
    } else if (request.status === 206) {
      this.offset = begin;
      if (this.data.byteLength < end + 1 - begin) {
        this.byteLength = begin + this.data.byteLength;
      }
    } else {
      throw request;
    }
  }
  reset() {
    this.data = void 0;
    this.dataView = void 0;
    this.offset = 0;
    this.byteLength = Number.MAX_SAFE_INTEGER;
  }
};

// ../core/dist/index.esm.js
var ct = Object.create;
var de = Object.defineProperty;
var dt = Object.getOwnPropertyDescriptor;
var mt = Object.getOwnPropertyNames;
var ht = Object.getPrototypeOf;
var ft = Object.prototype.hasOwnProperty;
var pt = (r) => de(r, "__esModule", {value: true});
var gt = (r, e) => () => (e || r((e = {exports: {}}).exports, e), e.exports);
var vt = (r, e, t) => {
  if (e && typeof e === "object" || typeof e === "function") {
    for (let n of mt(e))
      if (!ft.call(r, n) && n !== "default")
        de(r, n, {get: () => e[n], enumerable: !(t = dt(e, n)) || t.enumerable});
  }
  return r;
};
var bt = (r) => {
  return vt(pt(de(r != null ? ct(ht(r)) : {}, "default", r && r.__esModule && "default" in r ? {get: () => r.default, enumerable: true} : {value: r, enumerable: true})), r);
};
var Ze = gt((mr, ke) => {
  "use strict";
  var K = typeof Reflect === "object" ? Reflect : null;
  var Ke = K && typeof K.apply === "function" ? K.apply : function r(e, t, n) {
    return Function.prototype.apply.call(e, t, n);
  };
  var se;
  if (K && typeof K.ownKeys === "function") {
    se = K.ownKeys;
  } else if (Object.getOwnPropertySymbols) {
    se = function r(e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    };
  } else {
    se = function r(e) {
      return Object.getOwnPropertyNames(e);
    };
  }
  function Rt(r) {
    if (console && console.warn)
      console.warn(r);
  }
  var He = Number.isNaN || function r(e) {
    return e !== e;
  };
  function y() {
    y.init.call(this);
  }
  ke.exports = y;
  ke.exports.once = Vt;
  y.EventEmitter = y;
  y.prototype._events = void 0;
  y.prototype._eventsCount = 0;
  y.prototype._maxListeners = void 0;
  var ze = 10;
  function oe(r) {
    if (typeof r !== "function") {
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
    }
  }
  Object.defineProperty(y, "defaultMaxListeners", {enumerable: true, get: function() {
    return ze;
  }, set: function(r) {
    if (typeof r !== "number" || r < 0 || He(r)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + r + ".");
    }
    ze = r;
  }});
  y.init = function() {
    if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || void 0;
  };
  y.prototype.setMaxListeners = function r(e) {
    if (typeof e !== "number" || e < 0 || He(e)) {
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
    }
    this._maxListeners = e;
    return this;
  };
  function $e(r) {
    if (r._maxListeners === void 0)
      return y.defaultMaxListeners;
    return r._maxListeners;
  }
  y.prototype.getMaxListeners = function r() {
    return $e(this);
  };
  y.prototype.emit = function r(e) {
    var t = [];
    for (var n = 1; n < arguments.length; n++)
      t.push(arguments[n]);
    var i = e === "error";
    var s = this._events;
    if (s !== void 0)
      i = i && s.error === void 0;
    else if (!i)
      return false;
    if (i) {
      var o;
      if (t.length > 0)
        o = t[0];
      if (o instanceof Error) {
        throw o;
      }
      var u = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
      u.context = o;
      throw u;
    }
    var h = s[e];
    if (h === void 0)
      return false;
    if (typeof h === "function") {
      Ke(h, this, t);
    } else {
      var v = h.length;
      var b = Ge(h, v);
      for (var n = 0; n < v; ++n)
        Ke(b[n], this, t);
    }
    return true;
  };
  function We(r, e, t, n) {
    var i;
    var s;
    var o;
    oe(t);
    s = r._events;
    if (s === void 0) {
      s = r._events = Object.create(null);
      r._eventsCount = 0;
    } else {
      if (s.newListener !== void 0) {
        r.emit("newListener", e, t.listener ? t.listener : t);
        s = r._events;
      }
      o = s[e];
    }
    if (o === void 0) {
      o = s[e] = t;
      ++r._eventsCount;
    } else {
      if (typeof o === "function") {
        o = s[e] = n ? [t, o] : [o, t];
      } else if (n) {
        o.unshift(t);
      } else {
        o.push(t);
      }
      i = $e(r);
      if (i > 0 && o.length > i && !o.warned) {
        o.warned = true;
        var u = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning";
        u.emitter = r;
        u.type = e;
        u.count = o.length;
        Rt(u);
      }
    }
    return r;
  }
  y.prototype.addListener = function r(e, t) {
    return We(this, e, t, false);
  };
  y.prototype.on = y.prototype.addListener;
  y.prototype.prependListener = function r(e, t) {
    return We(this, e, t, true);
  };
  function At() {
    if (!this.fired) {
      this.target.removeListener(this.type, this.wrapFn);
      this.fired = true;
      if (arguments.length === 0)
        return this.listener.call(this.target);
      return this.listener.apply(this.target, arguments);
    }
  }
  function qe(r, e, t) {
    var n = {fired: false, wrapFn: void 0, target: r, type: e, listener: t};
    var i = At.bind(n);
    i.listener = t;
    n.wrapFn = i;
    return i;
  }
  y.prototype.once = function r(e, t) {
    oe(t);
    this.on(e, qe(this, e, t));
    return this;
  };
  y.prototype.prependOnceListener = function r(e, t) {
    oe(t);
    this.prependListener(e, qe(this, e, t));
    return this;
  };
  y.prototype.removeListener = function r(e, t) {
    var n, i, s, o, u;
    oe(t);
    i = this._events;
    if (i === void 0)
      return this;
    n = i[e];
    if (n === void 0)
      return this;
    if (n === t || n.listener === t) {
      if (--this._eventsCount === 0)
        this._events = Object.create(null);
      else {
        delete i[e];
        if (i.removeListener)
          this.emit("removeListener", e, n.listener || t);
      }
    } else if (typeof n !== "function") {
      s = -1;
      for (o = n.length - 1; o >= 0; o--) {
        if (n[o] === t || n[o].listener === t) {
          u = n[o].listener;
          s = o;
          break;
        }
      }
      if (s < 0)
        return this;
      if (s === 0)
        n.shift();
      else {
        Tt(n, s);
      }
      if (n.length === 1)
        i[e] = n[0];
      if (i.removeListener !== void 0)
        this.emit("removeListener", e, u || t);
    }
    return this;
  };
  y.prototype.off = y.prototype.removeListener;
  y.prototype.removeAllListeners = function r(e) {
    var t, n, i;
    n = this._events;
    if (n === void 0)
      return this;
    if (n.removeListener === void 0) {
      if (arguments.length === 0) {
        this._events = Object.create(null);
        this._eventsCount = 0;
      } else if (n[e] !== void 0) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else
          delete n[e];
      }
      return this;
    }
    if (arguments.length === 0) {
      var s = Object.keys(n);
      var o;
      for (i = 0; i < s.length; ++i) {
        o = s[i];
        if (o === "removeListener")
          continue;
        this.removeAllListeners(o);
      }
      this.removeAllListeners("removeListener");
      this._events = Object.create(null);
      this._eventsCount = 0;
      return this;
    }
    t = n[e];
    if (typeof t === "function") {
      this.removeListener(e, t);
    } else if (t !== void 0) {
      for (i = t.length - 1; i >= 0; i--) {
        this.removeListener(e, t[i]);
      }
    }
    return this;
  };
  function Qe(r, e, t) {
    var n = r._events;
    if (n === void 0)
      return [];
    var i = n[e];
    if (i === void 0)
      return [];
    if (typeof i === "function")
      return t ? [i.listener || i] : [i];
    return t ? Nt(i) : Ge(i, i.length);
  }
  y.prototype.listeners = function r(e) {
    return Qe(this, e, true);
  };
  y.prototype.rawListeners = function r(e) {
    return Qe(this, e, false);
  };
  y.listenerCount = function(r, e) {
    if (typeof r.listenerCount === "function") {
      return r.listenerCount(e);
    } else {
      return Ye.call(r, e);
    }
  };
  y.prototype.listenerCount = Ye;
  function Ye(r) {
    var e = this._events;
    if (e !== void 0) {
      var t = e[r];
      if (typeof t === "function") {
        return 1;
      } else if (t !== void 0) {
        return t.length;
      }
    }
    return 0;
  }
  y.prototype.eventNames = function r() {
    return this._eventsCount > 0 ? se(this._events) : [];
  };
  function Ge(r, e) {
    var t = new Array(e);
    for (var n = 0; n < e; ++n)
      t[n] = r[n];
    return t;
  }
  function Tt(r, e) {
    for (; e + 1 < r.length; e++)
      r[e] = r[e + 1];
    r.pop();
  }
  function Nt(r) {
    var e = new Array(r.length);
    for (var t = 0; t < e.length; ++t) {
      e[t] = r[t].listener || r[t];
    }
    return e;
  }
  function Vt(r, e) {
    return new Promise(function(t, n) {
      function i(o) {
        r.removeListener(e, s);
        n(o);
      }
      function s() {
        if (typeof r.removeListener === "function") {
          r.removeListener("error", i);
        }
        t([].slice.call(arguments));
      }
      ;
      Je(r, e, s, {once: true});
      if (e !== "error") {
        It(r, i, {once: true});
      }
    });
  }
  function It(r, e, t) {
    if (typeof r.on === "function") {
      Je(r, "error", e, t);
    }
  }
  function Je(r, e, t, n) {
    if (typeof r.on === "function") {
      if (n.once) {
        r.once(e, t);
      } else {
        r.on(e, t);
      }
    } else if (typeof r.addEventListener === "function") {
      r.addEventListener(e, function i(s) {
        if (n.once) {
          r.removeEventListener(e, i);
        }
        t(s);
      });
    } else {
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof r);
    }
  }
});
var k;
(function(p) {
  p["PluginAdded"] = "pluginAdded";
  p["PluginRemoved"] = "pluginRemoved";
  p["StatusChanged"] = "playerStatusChanged";
  p["Muted"] = "playerMuted";
  p["Unmuted"] = "playerUnmuted";
  p["Ended"] = "ended";
  p["QualityChanged"] = "qualityChanged";
  p["AudioChanged"] = "audioChanged";
  p["AdapterChanged"] = "adapterChanged";
  p["ChannelChanged"] = "audioChannelChanged";
  p["Loading"] = "playerLoading";
  p["Loaded"] = "playerLoaded";
  p["DropFrameChanged"] = "dropFrameChanged";
  p["FrameOffsetChanged"] = "frameOffsetChanged";
  p["UserPause"] = "userPause";
  p["Error"] = "playerError";
  p["LoopPlayback"] = "playerLoopPlayback";
  p["LoopPlaybackCanceled"] = "playerLoopPlaybackCanceled";
})(k || (k = {}));
var g;
(function(f) {
  f["Ended"] = "internalEnded";
  f["Mute"] = "internalMute";
  f["Unmute"] = "internalUnmute";
  f["LoadedChanged"] = "internalLoadedChanged";
  f["MutedChanged"] = "internalMutedChanged";
  f["Seek"] = "internalSeek";
  f["Seeked"] = "internalSeeked";
  f["Play"] = "internalPlay";
  f["Pause"] = "internalPause";
  f["TimeUpdate"] = "internalTimeupdate";
  f["VideoFileLoading"] = "internalVideoFileLoading";
  f["VideoFileLoaded"] = "internalVideoFileLoaded";
  f["VideoSourceChanged"] = "internalVideoSourceChanged";
})(g || (g = {}));
var V;
(function(a) {
  a["Abort"] = "abort";
  a["CanPlay"] = "canplay";
  a["CanPlayThrough"] = "canplaythrough";
  a["DurationChange"] = "durationchange";
  a["Emptied"] = "emptied";
  a["Encrypted"] = "encrypted";
  a["Ended"] = "ended";
  a["Error"] = "error";
  a["Load"] = "load";
  a["LoadedData"] = "loadeddata";
  a["LoadedMetadata"] = "loadedmetadata";
  a["LoadStart"] = "loadstart";
  a["Pause"] = "pause";
  a["Play"] = "play";
  a["Playing"] = "playing";
  a["Progress"] = "progress";
  a["RateChange"] = "ratechange";
  a["Seeked"] = "seeked";
  a["Seeking"] = "seeking";
  a["Stalled"] = "stalled";
  a["Suspend"] = "suspend";
  a["TimeUpdate"] = "timeupdate";
  a["VolumeChange"] = "volumechange";
  a["Waiting"] = "waiting";
})(V || (V = {}));
var re;
(function(s) {
  s[s["HaveNothing"] = 0] = "HaveNothing";
  s[s["HaveMetadata"] = 1] = "HaveMetadata";
  s[s["HaveCurrentData"] = 2] = "HaveCurrentData";
  s[s["HaveFutureData"] = 3] = "HaveFutureData";
  s[s["HaveEnoughData"] = 4] = "HaveEnoughData";
})(re || (re = {}));
var Ee;
(function(r) {
  r[r["Timecode"] = 0] = "Timecode";
  r[r["Frame"] = 1] = "Frame";
  r[r["Time"] = 2] = "Time";
  r[r["Seconds"] = 3] = "Seconds";
  r[r["Milliseconds"] = 4] = "Milliseconds";
  r[r["Percent"] = 5] = "Percent";
})(Ee || (Ee = {}));
var Re;
(function(r) {
  r[r["Round"] = 0] = "Round";
  r[r["Ceil"] = 1] = "Ceil";
  r[r["Floor"] = 2] = "Floor";
})(Re || (Re = {}));
var Ae = ";";
var Mt = new RegExp(Ae, "g");
var Xe = bt(Ze());
var $ = class {
  static create(...e) {
    return new this(...e);
  }
  mixIn(e) {
    return Object.assign(this, e);
  }
  clone() {
    const e = new this.constructor();
    Object.assign(e, this);
    return e;
  }
};
var A = class extends $ {
  constructor(e = [], t = e.length * 4) {
    super();
    let n = e;
    if (n instanceof ArrayBuffer) {
      n = new Uint8Array(n);
    }
    if (n instanceof Int8Array || n instanceof Uint8ClampedArray || n instanceof Int16Array || n instanceof Uint16Array || n instanceof Int32Array || n instanceof Uint32Array || n instanceof Float32Array || n instanceof Float64Array) {
      n = new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
    }
    if (n instanceof Uint8Array) {
      const i = n.byteLength;
      const s = [];
      for (let o = 0; o < i; o += 1) {
        s[o >>> 2] |= n[o] << 24 - o % 4 * 8;
      }
      this.words = s;
      this.sigBytes = i;
    } else {
      this.words = e;
      this.sigBytes = t;
    }
  }
  static random(e) {
    const t = [];
    const n = (i) => {
      let s = i;
      let o = 987654321;
      const u = 4294967295;
      return () => {
        o = 36969 * (o & 65535) + (o >> 16) & u;
        s = 18e3 * (s & 65535) + (s >> 16) & u;
        let h = (o << 16) + s & u;
        h /= 4294967296;
        h += 0.5;
        return h * (Math.random() > 0.5 ? 1 : -1);
      };
    };
    for (let i = 0, s; i < e; i += 4) {
      const o = n((s || Math.random()) * 4294967296);
      s = o() * 987654071;
      t.push(o() * 4294967296 | 0);
    }
    return new A(t, e);
  }
  toString(e = Se) {
    return e.stringify(this);
  }
  concat(e) {
    const t = this.words;
    const n = e.words;
    const i = this.sigBytes;
    const s = e.sigBytes;
    this.clamp();
    if (i % 4) {
      for (let o = 0; o < s; o += 1) {
        const u = n[o >>> 2] >>> 24 - o % 4 * 8 & 255;
        t[i + o >>> 2] |= u << 24 - (i + o) % 4 * 8;
      }
    } else {
      for (let o = 0; o < s; o += 4) {
        t[i + o >>> 2] = n[o >>> 2];
      }
    }
    this.sigBytes += s;
    return this;
  }
  clamp() {
    const {words: e, sigBytes: t} = this;
    e[t >>> 2] &= 4294967295 << 32 - t % 4 * 8;
    e.length = Math.ceil(t / 4);
  }
  clone() {
    const e = super.clone.call(this);
    e.words = this.words.slice(0);
    return e;
  }
};
var Se = {stringify(r) {
  const {words: e, sigBytes: t} = r;
  const n = [];
  for (let i = 0; i < t; i += 1) {
    const s = e[i >>> 2] >>> 24 - i % 4 * 8 & 255;
    n.push((s >>> 4).toString(16));
    n.push((s & 15).toString(16));
  }
  return n.join("");
}, parse(r) {
  const e = r.length;
  const t = [];
  for (let n = 0; n < e; n += 2) {
    t[n >>> 3] |= parseInt(r.substr(n, 2), 16) << 24 - n % 8 * 4;
  }
  return new A(t, e / 2);
}};
var ue = {stringify(r) {
  const {words: e, sigBytes: t} = r;
  const n = [];
  for (let i = 0; i < t; i += 1) {
    const s = e[i >>> 2] >>> 24 - i % 4 * 8 & 255;
    n.push(String.fromCharCode(s));
  }
  return n.join("");
}, parse(r) {
  const e = r.length;
  const t = [];
  for (let n = 0; n < e; n += 1) {
    t[n >>> 2] |= (r.charCodeAt(n) & 255) << 24 - n % 4 * 8;
  }
  return new A(t, e);
}};
var et = {stringify(r) {
  try {
    return decodeURIComponent(escape(ue.stringify(r)));
  } catch (e) {
    throw new Error("Malformed UTF-8 data");
  }
}, parse(r) {
  return ue.parse(unescape(encodeURIComponent(r)));
}};
var tt = class extends $ {
  constructor() {
    super();
    this._minBufferSize = 0;
  }
  reset() {
    this._data = new A();
    this._nDataBytes = 0;
  }
  _append(e) {
    let t = e;
    if (typeof t === "string") {
      t = et.parse(t);
    }
    this._data.concat(t);
    this._nDataBytes += t.sigBytes;
  }
  _process(e) {
    let t;
    const {_data: n, blockSize: i} = this;
    const s = n.words;
    const o = n.sigBytes;
    const u = i * 4;
    let h = o / u;
    if (e) {
      h = Math.ceil(h);
    } else {
      h = Math.max((h | 0) - this._minBufferSize, 0);
    }
    const v = h * i;
    const b = Math.min(v * 4, o);
    if (v) {
      for (let x = 0; x < v; x += i) {
        this._doProcessBlock(s, x);
      }
      t = s.splice(0, v);
      n.sigBytes -= b;
    }
    return new A(t, b);
  }
  clone() {
    const e = super.clone.call(this);
    e._data = this._data.clone();
    return e;
  }
};
var W = class extends tt {
  constructor(e) {
    super();
    this.blockSize = 512 / 32;
    this.cfg = Object.assign(new $(), e);
    this.reset();
  }
  static _createHelper(e) {
    return (t, n) => new e(n).finalize(t);
  }
  static _createHmacHelper(e) {
    return (t, n) => new rt(e, n).finalize(t);
  }
  reset() {
    super.reset.call(this);
    this._doReset();
  }
  update(e) {
    this._append(e);
    this._process();
    return this;
  }
  finalize(e) {
    if (e) {
      this._append(e);
    }
    const t = this._doFinalize();
    return t;
  }
};
var rt = class extends $ {
  constructor(e, t) {
    super();
    const n = new e();
    this._hasher = n;
    let i = t;
    if (typeof i === "string") {
      i = et.parse(i);
    }
    const s = n.blockSize;
    const o = s * 4;
    if (i.sigBytes > o) {
      i = n.finalize(t);
    }
    i.clamp();
    const u = i.clone();
    this._oKey = u;
    const h = i.clone();
    this._iKey = h;
    const v = u.words;
    const b = h.words;
    for (let x = 0; x < s; x += 1) {
      v[x] ^= 1549556828;
      b[x] ^= 909522486;
    }
    u.sigBytes = o;
    h.sigBytes = o;
    this.reset();
  }
  reset() {
    const e = this._hasher;
    e.reset();
    e.update(this._iKey);
  }
  update(e) {
    this._hasher.update(e);
    return this;
  }
  finalize(e) {
    const t = this._hasher;
    const n = t.finalize(e);
    t.reset();
    const i = t.finalize(this._oKey.clone().concat(n));
    return i;
  }
};
var m = [];
for (let r = 0; r < 64; r += 1) {
  m[r] = Math.abs(Math.sin(r + 1)) * 4294967296 | 0;
}
var M = (r, e, t, n, i, s, o) => {
  const u = r + (e & t | ~e & n) + i + o;
  return (u << s | u >>> 32 - s) + e;
};
var F = (r, e, t, n, i, s, o) => {
  const u = r + (e & n | t & ~n) + i + o;
  return (u << s | u >>> 32 - s) + e;
};
var w = (r, e, t, n, i, s, o) => {
  const u = r + (e ^ t ^ n) + i + o;
  return (u << s | u >>> 32 - s) + e;
};
var C = (r, e, t, n, i, s, o) => {
  const u = r + (t ^ (e | ~n)) + i + o;
  return (u << s | u >>> 32 - s) + e;
};
var _e = class extends W {
  _doReset() {
    this._hash = new A([1732584193, 4023233417, 2562383102, 271733878]);
  }
  _doProcessBlock(e, t) {
    const n = e;
    for (let ce = 0; ce < 16; ce += 1) {
      const Le = t + ce;
      const te = e[Le];
      n[Le] = (te << 8 | te >>> 24) & 16711935 | (te << 24 | te >>> 8) & 4278255360;
    }
    const i = this._hash.words;
    const s = n[t + 0];
    const o = n[t + 1];
    const u = n[t + 2];
    const h = n[t + 3];
    const v = n[t + 4];
    const b = n[t + 5];
    const x = n[t + 6];
    const P = n[t + 7];
    const f = n[t + 8];
    const L = n[t + 9];
    const j = n[t + 10];
    const T = n[t + 11];
    const Z = n[t + 12];
    const p = n[t + 13];
    const X = n[t + 14];
    const ee = n[t + 15];
    let l = i[0];
    let c = i[1];
    let d = i[2];
    let a = i[3];
    l = M(l, c, d, a, s, 7, m[0]);
    a = M(a, l, c, d, o, 12, m[1]);
    d = M(d, a, l, c, u, 17, m[2]);
    c = M(c, d, a, l, h, 22, m[3]);
    l = M(l, c, d, a, v, 7, m[4]);
    a = M(a, l, c, d, b, 12, m[5]);
    d = M(d, a, l, c, x, 17, m[6]);
    c = M(c, d, a, l, P, 22, m[7]);
    l = M(l, c, d, a, f, 7, m[8]);
    a = M(a, l, c, d, L, 12, m[9]);
    d = M(d, a, l, c, j, 17, m[10]);
    c = M(c, d, a, l, T, 22, m[11]);
    l = M(l, c, d, a, Z, 7, m[12]);
    a = M(a, l, c, d, p, 12, m[13]);
    d = M(d, a, l, c, X, 17, m[14]);
    c = M(c, d, a, l, ee, 22, m[15]);
    l = F(l, c, d, a, o, 5, m[16]);
    a = F(a, l, c, d, x, 9, m[17]);
    d = F(d, a, l, c, T, 14, m[18]);
    c = F(c, d, a, l, s, 20, m[19]);
    l = F(l, c, d, a, b, 5, m[20]);
    a = F(a, l, c, d, j, 9, m[21]);
    d = F(d, a, l, c, ee, 14, m[22]);
    c = F(c, d, a, l, v, 20, m[23]);
    l = F(l, c, d, a, L, 5, m[24]);
    a = F(a, l, c, d, X, 9, m[25]);
    d = F(d, a, l, c, h, 14, m[26]);
    c = F(c, d, a, l, f, 20, m[27]);
    l = F(l, c, d, a, p, 5, m[28]);
    a = F(a, l, c, d, u, 9, m[29]);
    d = F(d, a, l, c, P, 14, m[30]);
    c = F(c, d, a, l, Z, 20, m[31]);
    l = w(l, c, d, a, b, 4, m[32]);
    a = w(a, l, c, d, f, 11, m[33]);
    d = w(d, a, l, c, T, 16, m[34]);
    c = w(c, d, a, l, X, 23, m[35]);
    l = w(l, c, d, a, o, 4, m[36]);
    a = w(a, l, c, d, v, 11, m[37]);
    d = w(d, a, l, c, P, 16, m[38]);
    c = w(c, d, a, l, j, 23, m[39]);
    l = w(l, c, d, a, p, 4, m[40]);
    a = w(a, l, c, d, s, 11, m[41]);
    d = w(d, a, l, c, h, 16, m[42]);
    c = w(c, d, a, l, x, 23, m[43]);
    l = w(l, c, d, a, L, 4, m[44]);
    a = w(a, l, c, d, Z, 11, m[45]);
    d = w(d, a, l, c, ee, 16, m[46]);
    c = w(c, d, a, l, u, 23, m[47]);
    l = C(l, c, d, a, s, 6, m[48]);
    a = C(a, l, c, d, P, 10, m[49]);
    d = C(d, a, l, c, X, 15, m[50]);
    c = C(c, d, a, l, b, 21, m[51]);
    l = C(l, c, d, a, Z, 6, m[52]);
    a = C(a, l, c, d, h, 10, m[53]);
    d = C(d, a, l, c, j, 15, m[54]);
    c = C(c, d, a, l, o, 21, m[55]);
    l = C(l, c, d, a, f, 6, m[56]);
    a = C(a, l, c, d, ee, 10, m[57]);
    d = C(d, a, l, c, x, 15, m[58]);
    c = C(c, d, a, l, p, 21, m[59]);
    l = C(l, c, d, a, v, 6, m[60]);
    a = C(a, l, c, d, T, 10, m[61]);
    d = C(d, a, l, c, u, 15, m[62]);
    c = C(c, d, a, l, L, 21, m[63]);
    i[0] = i[0] + l | 0;
    i[1] = i[1] + c | 0;
    i[2] = i[2] + d | 0;
    i[3] = i[3] + a | 0;
  }
  _doFinalize() {
    const e = this._data;
    const t = e.words;
    const n = this._nDataBytes * 8;
    const i = e.sigBytes * 8;
    t[i >>> 5] |= 128 << 24 - i % 32;
    const s = Math.floor(n / 4294967296);
    const o = n;
    t[(i + 64 >>> 9 << 4) + 15] = (s << 8 | s >>> 24) & 16711935 | (s << 24 | s >>> 8) & 4278255360;
    t[(i + 64 >>> 9 << 4) + 14] = (o << 8 | o >>> 24) & 16711935 | (o << 24 | o >>> 8) & 4278255360;
    e.sigBytes = (t.length + 1) * 4;
    this._process();
    const u = this._hash;
    const h = u.words;
    for (let v = 0; v < 4; v += 1) {
      const b = h[v];
      h[v] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360;
    }
    return u;
  }
  clone() {
    const e = super.clone.call(this);
    e._hash = this._hash.clone();
    return e;
  }
};
var gr = W._createHelper(_e);
var nt = W._createHmacHelper(_e);
var q = {HmacMD5: nt, enc: {Latin1: ue, Hex: Se}};
var Bt = {baseUrl: "https://license.accurateplayer.com/api", initialTimeout: 3e3, retryAttempts: 3, retryTimeout: 1e4, sessionTimeMin: 6e4};
var Ot = {singleRun: false, extraData: {}};
var it = async (r) => {
  return new Promise((e) => {
    setTimeout(() => e(), r);
  });
};
var st = class {
  constructor(r, e) {
    this.started = false;
    this.callback = r;
    this.remaining = e;
  }
  start() {
    this.started = true;
    this.resume();
  }
  pause() {
    if (this.started) {
      window.clearTimeout(this.timerId);
      this.remaining -= new Date().getTime() - this.startTime.getTime();
    }
  }
  resume() {
    if (this.started) {
      this.startTime = new Date();
      this.timerId = window.setTimeout(this.callback, this.remaining);
    }
  }
  clear() {
    window.clearTimeout(this.timerId);
    this.timerId = void 0;
  }
};
var B = class {
  constructor(r, e, t, n) {
    this.keys = r;
    this.callback = e;
    this.extraData = t;
    this.options = n;
    this.handleVisibilityChange = () => {
      var i, s;
      if (document.hidden) {
        (i = this.sessionTimer) == null ? void 0 : i.pause();
      } else {
        (s = this.sessionTimer) == null ? void 0 : s.resume();
      }
    };
    this.opts = {...Bt, ...n};
    document.addEventListener("visibilitychange", this.handleVisibilityChange, false);
    this.sessionTimer = new st(() => ({}), 0);
  }
  static timestampIsCurrent(r) {
    if (!r) {
      return false;
    }
    return new Date().getTime() < new Date(r).getTime();
  }
  saveResponse(r) {
    localStorage.setItem(this.cachedResponseStorageKey(), JSON.stringify({response: r.response, timestamp: r.timestamp, expires: r.expires, licensedProducts: r.licensedProducts}));
  }
  async verifyImmediately(r) {
    const e = {...Ot, ...r};
    if (!this.keys.customerKey) {
      this.callback(false, "No license key provided.");
      return;
    }
    const t = this.verifyFromServer(e);
    const n = it(1e3).then(() => this.getFromLocalstorage());
    try {
      const s = await Promise.race([t, n]);
      if (this.verifyFromData(s)) {
        this.invokeSuccessfulCallback(s, e);
        return;
      }
    } catch {
    }
    const i = await t;
    if (this.verifyFromData(i)) {
      this.invokeSuccessfulCallback(i, e);
    } else {
      this.callback(false, i.message);
    }
  }
  verify(r) {
    if (this.keys.customerKey === atob("NzVlZDNlYjQ2LTQ3MGQtNDVkNi1hZjM5LWE1ZWJkNjc4MGMzMEFy").substring(1, 37)) {
      this.callback(true);
      return;
    }
    this.initialTimer = window.setTimeout(() => this.verifyImmediately(r), this.opts.initialTimeout);
  }
  verifyChecksum(r, e) {
    if (!B.timestampIsCurrent(r)) {
      return false;
    }
    return q.HmacMD5(q.enc.Latin1.parse(r), q.enc.Hex.parse(this.privateKey()).concat(q.enc.Hex.parse(this.keys.productKey))).toString(q.enc.Hex).toUpperCase() === e.toUpperCase();
  }
  privateKey() {
    return this.keys.customerKey.split("U")[0];
  }
  publicKey() {
    return this.keys.customerKey.split("U")[1];
  }
  cachedResponseStorageKey() {
    return "ap.license." + this.keys.productKey + ".cached";
  }
  getFromLocalstorage() {
    const r = JSON.parse(localStorage.getItem(this.cachedResponseStorageKey()));
    return r;
  }
  verifyFromData(r) {
    return r && this.verifyChecksum(r.timestamp, r.response);
  }
  invokeSuccessfulCallback(r, e) {
    this.callback(true, void 0, {expires: r.expires, licensedProducts: r.licensedProducts});
    if (!e.singleRun && "sessionTime" in r) {
      const {sessionTimeMin: t} = this.opts;
      if (!("session_time_trigger" in e.extraData)) {
        e.extraData.session_time_trigger = true;
      }
      this.sessionTimer = new st(() => this.verifyImmediately(e), Math.max(r.sessionTime, t));
      this.sessionTimer.start();
    }
  }
  async verifyFromServer(r) {
    var e;
    let t;
    for (let n = 0; n < this.opts.retryAttempts; n++) {
      try {
        const i = await fetch(this.buildUrl(r));
        t = await i.json();
        break;
      } catch (i) {
      }
      await it(this.opts.retryTimeout);
    }
    if (this.verifyFromData(t)) {
      this.saveResponse(t);
      return t;
    } else {
      return {ok: false, message: (e = t == null ? void 0 : t.message) != null ? e : "Error contacting license server"};
    }
  }
  buildUrl(r) {
    this.generateId();
    let e = this.opts.baseUrl + "/license/verify/v1?key=" + encodeURIComponent(this.publicKey()) + "&timestamp=" + new Date().toISOString() + "&product=" + encodeURIComponent(this.keys.productKey) + "&_id=" + encodeURIComponent(localStorage.getItem(B.ID_KEY)) + "&_date=" + encodeURIComponent(localStorage.getItem(B.ID_TS_KEY));
    e += this.toExtraDataParams(this.extraData);
    e += this.toExtraDataParams(r.extraData);
    return e;
  }
  toExtraDataParams(r) {
    let e = "";
    for (const t in r) {
      if (Object.prototype.hasOwnProperty.call(r, t)) {
        e += "&_" + encodeURIComponent(t) + "=" + encodeURIComponent(r[t]);
      }
    }
    return e;
  }
  generateId() {
    const r = localStorage.getItem(B.ID_TS_KEY);
    const e = this.getDate();
    if (r === e) {
      return;
    }
    let t = "";
    for (let n = 0; n < 8; n++) {
      const i = "000" + Math.round(Math.random() * 256).toString(16);
      const s = i.substr(i.length - 2);
      t += s;
    }
    localStorage.setItem(B.ID_TS_KEY, e);
    localStorage.setItem(B.ID_KEY, t);
  }
  getDate() {
    const r = new Date();
    return r.getFullYear() + "-" + ("0" + (r.getMonth() + 1)).slice(-2) + "-" + ("0" + r.getDate()).slice(-2);
  }
  destroy() {
    window.clearTimeout(this.initialTimer);
    window.clearTimeout(this.retryTimer);
    this.sessionTimer.clear();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
};
var le = B;
le.ID_TS_KEY = "ap.licence.id.ts";
le.ID_KEY = "ap.licence.id";
var _;
(function(o) {
  o[o["Timecode"] = 0] = "Timecode";
  o[o["Frame"] = 1] = "Frame";
  o[o["Time"] = 2] = "Time";
  o[o["Seconds"] = 3] = "Seconds";
  o[o["Milliseconds"] = 4] = "Milliseconds";
  o[o["Percent"] = 5] = "Percent";
})(_ || (_ = {}));
var Q;
(function(n) {
  n[n["Round"] = 0] = "Round";
  n[n["Ceil"] = 1] = "Ceil";
  n[n["Floor"] = 2] = "Floor";
})(Q || (Q = {}));
var O;
(function(n) {
  n[n["RelativeBackward"] = 0] = "RelativeBackward";
  n[n["RelativeForward"] = 1] = "RelativeForward";
  n[n["Absolute"] = 2] = "Absolute";
})(O || (O = {}));
var Y;
(function(t) {
  t[t["QueuedSeek"] = 0] = "QueuedSeek";
  t[t["RegularSeek"] = 1] = "RegularSeek";
})(Y || (Y = {}));
var Ut = Reflect.ownKeys;
var Wt = [24, 24e3 / 1001, 25, 30, 3e4 / 1001, 50, 60, 6e4 / 1001, 120, 12e4 / 1001];
var qt = [3e4 / 1001, 6e4 / 1001];
function yn() {
  return Ce("firefox");
}
function Gt() {
  return Ce("chrome");
}
function xn() {
  return !Gt() && Ce("safari");
}
function Ce(r) {
  return Boolean(navigator.userAgent.match(new RegExp(r, "i")));
}

// src/util.ts
function arrayMin(values) {
  if (!values) {
    return;
  }
  let m2 = values[0];
  for (let i = values.length - 1; i >= 0; i--) {
    if (values[i] < m2) {
      m2 = values[i];
    }
  }
  return m2;
}

// src/parse-mp4.ts
async function getMediaInfo(src, partialFile) {
  var _a, _b;
  const requester = new RangeRequester(src);
  const parsed = await parseMp4(requester);
  const sortedStreams = parsed.streams.sort((a, b) => {
    return a.track_id - b.track_id;
  });
  const videoStream = sortedStreams.find((stream) => stream.is_video);
  const audioStream = sortedStreams.find((stream) => stream.is_audio);
  const offset = getStartOffset(parsed, videoStream);
  if (!(partialFile && partialFile.frameRate || videoStream && videoStream.fps)) {
    return Promise.reject({
      status: -1,
      statusText: "Could not parse frame rate of video file."
    });
  }
  const duration = parsed.duration && parsed.time_scale && videoStream && videoStream.fps ? Math.round(parsed.duration / parsed.time_scale * videoStream.fps) : void 0;
  const audioStreamChannels = audioStream && audioStream.aac_channels ? audioStream.aac_channels : audioStream && audioStream.channels ? audioStream.channels : 0;
  return {
    ...partialFile,
    src,
    frameRate: partialFile && partialFile.frameRate ? partialFile.frameRate : {numerator: videoStream.fps, denominator: 1},
    channelCount: partialFile && partialFile.channelCount ? partialFile.channelCount : audioStreamChannels,
    videoStartOffset: offset,
    duration: (_b = (_a = videoStream == null ? void 0 : videoStream.ts) == null ? void 0 : _a.length) != null ? _b : duration,
    vfr: videoStream == null ? void 0 : videoStream.vfr,
    ts: videoStream == null ? void 0 : videoStream.ts,
    time_scale: videoStream == null ? void 0 : videoStream.time_scale,
    accurate: parsed.accurate
  };
}
function getStartOffset(parsed, videoStream) {
  let offset = 0;
  if (parsed.start_offset && parsed.start_offset >= 0.25 / videoStream.fps) {
    if (Gt()) {
      offset = parsed.start_offset;
    } else if (yn()) {
      offset = Math.min(parsed.start_offset, 1 / videoStream.fps);
    }
    offset = Number(offset.toFixed(6));
  }
  return offset;
}
async function parseMp4(requester) {
  const offset = await requester.getUint32(0);
  const atom_name = await requester.getString(4, 4);
  if (offset < 8 || atom_name !== "ftyp") {
    throw new Error("File format is not ISO base media (mp4/mov)");
  }
  let atoms = [
    {
      offset,
      name: atom_name,
      level: 0
    }
  ];
  const media_info = {
    streams: [],
    start_offset: 0,
    audio_track_count: 0,
    accurate: true
  };
  atoms = atoms.concat(await parseAtoms(requester, offset, requester.byteLength, 0, media_info, void 0));
  let video_stream;
  let audio_stream;
  for (let i = 0; i < media_info.streams.length; i++) {
    if (media_info.streams[i].inaccurate) {
      media_info.accurate = false;
    }
    if (media_info.streams[i].is_video && (!video_stream || media_info.streams[i].stream_id < video_stream.stream_id)) {
      video_stream = media_info.streams[i];
    } else if (media_info.streams[i].is_audio && (!audio_stream || media_info.streams[i].stream_id < audio_stream.stream_id)) {
      audio_stream = media_info.streams[i];
    }
  }
  media_info.audio_track_count = media_info.streams.filter((s) => s.is_audio).length;
  if (media_info.audio_track_count > 1) {
    console.warn("Multiple audio tracks found. Frame accuracy not guaranteed.");
    media_info.accurate = false;
  }
  if (!video_stream) {
    return media_info;
  }
  for (let i = 0; i < video_stream.ts.length; i++) {
    video_stream.ts[i].pts -= video_stream.first_pts;
    video_stream.ts[i].sts = video_stream.ts[i].pts / video_stream.time_scale;
    video_stream.ts[i].delta /= video_stream.time_scale;
  }
  if (!video_stream.vfr) {
    console.debug("og");
    if (video_stream && audio_stream) {
      let video_start = video_stream.ptss[0] / video_stream.time_scale;
      let audio_start = audio_stream.ptss[0] / audio_stream.time_scale;
      if (video_stream.elst_start) {
        video_start -= video_stream.elst_start / video_stream.time_scale;
      }
      if (audio_stream.elst_start) {
        audio_start -= audio_stream.elst_start / audio_stream.time_scale;
      }
      media_info.start_offset = video_start - audio_start;
    }
    let off = 0;
    if (media_info.start_offset && media_info.start_offset >= 0.25 / video_stream.fps) {
      console.debug("og");
      if (Gt()) {
        off = media_info.start_offset;
      } else if (yn()) {
        off = Math.min(media_info.start_offset, 1 / video_stream.fps);
      }
      off = Number(off.toFixed(6));
    }
    for (let i = 0; i < video_stream.ts.length; i++) {
      video_stream.ts[i].sts += off + 100001e-8;
    }
    return media_info;
  }
  if (video_stream.first_pts === 0 && !video_stream.elst_start) {
    console.debug("00");
    for (let i = 0; i < video_stream.ts.length; i++) {
      video_stream.ts[i].sts += 100001e-8;
    }
    return media_info;
  } else if (video_stream.first_pts !== 0 && video_stream.elst_start == null) {
    console.warn("Non-zero PTS and no edit list. Frame accuracy not guaranteed.");
    media_info.accurate = false;
  } else if (video_stream.first_pts !== video_stream.elst_start) {
    console.warn("Edit list discrepancy. Frame accuracy not guaranteed.");
    media_info.accurate = false;
  }
  if (yn()) {
    const d = video_stream.first_pts / video_stream.time_scale * 0.5 - video_stream.ts[0].delta;
    if (d < 11e-4) {
      console.debug("firefox", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
    } else {
      console.debug("Firefox", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
      for (let i = 0; i < video_stream.ts.length - 1; i++) {
        video_stream.ts[i].sts = video_stream.ts[i + 1].sts;
      }
    }
    for (let i = 0; i < video_stream.ts.length; i++) {
      video_stream.ts[i].sts += 100001e-8;
    }
    return media_info;
  }
  if (Gt()) {
    const d = video_stream.first_pts / video_stream.time_scale * 0.5 - video_stream.ts[0].delta;
    if (d < 11e-4) {
      console.debug("chrome", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
      for (let i = 0; i < video_stream.ts.length - 1; i++) {
        video_stream.ts[i].sts = video_stream.ts[i].sts += video_stream.first_pts / video_stream.time_scale * 0.5 - 100001e-8;
      }
    } else {
      console.debug("Chrome", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
      for (let i = 0; i < video_stream.ts.length - 1; i++) {
        video_stream.ts[i].sts = video_stream.ts[i + 1].sts + video_stream.ts[i + 1].delta / 4 + 100001e-8;
      }
    }
    return media_info;
  }
  if (xn()) {
    const d = video_stream.first_pts / video_stream.time_scale * 0.5 - video_stream.ts[0].delta;
    if (d < 11e-4) {
      console.debug("safari", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
      for (let i = 0; i < video_stream.ts.length - 1; i++) {
        video_stream.ts[i].sts = video_stream.ts[i + 1].sts - 100001e-8;
      }
    } else {
      console.debug("Safari", video_stream.first_pts / video_stream.time_scale, video_stream.ts[0].delta);
      for (let i = 0; i < video_stream.ts.length - 1; i++) {
        video_stream.ts[i].sts = video_stream.ts[i + 1].sts + 100001e-8;
      }
    }
    return media_info;
  }
  console.warn("Unknown browser. Frame accuracy not guaranteed.");
  media_info.accurate = false;
  return media_info;
}
function getAacSampleRate(aac_data) {
  switch (aac_data) {
    case 0:
      return 96e3;
    case 1:
      return 88200;
    case 2:
      return 64e3;
    case 3:
      return 48e3;
    case 4:
      return 44100;
    case 5:
      return 32e3;
    case 6:
      return 24e3;
    case 7:
      return 22050;
    case 8:
      return 16e3;
    case 9:
      return 12e3;
    case 10:
      return 11025;
    case 11:
      return 8e3;
    case 12:
      return 7350;
    default:
      break;
  }
}
function getAacChannels(aac_data) {
  switch (aac_data) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return aac_data;
    case 7:
      return 8;
    default:
      break;
  }
}
async function parseAtoms(requester, offset, end_of_file, level, media_info, stream) {
  let atoms = [];
  while (offset < end_of_file && offset < requester.getByteLength()) {
    let box_size = await requester.getUint32(offset);
    const atom_name = await requester.getString(offset + 4, 4);
    if (box_size < 8) {
      if (box_size === 0) {
        box_size = end_of_file - offset;
      } else if (box_size === 1 && atom_name === "mdat") {
        box_size = await requester.getUint64(offset + 8);
      } else {
        console.warn("invalid atom", atom_name, "with size", box_size);
        return atoms;
      }
    }
    const atom = {
      offset,
      name: atom_name,
      level
    };
    atoms.push(atom);
    offset += box_size;
    if (atom_name === "ctts") {
      stream.ctts = atom;
    } else if (atom_name === "stts") {
      stream.stts = atom;
    } else if (atom_name === "elst") {
      const version = await requester.getUint8(atom.offset + 8);
      const edit_count = await requester.getUint32(atom.offset + 12);
      if (edit_count === 1) {
        if (version === 1) {
          stream.elst_length = await requester.getUint64(atom.offset + 16);
          stream.elst_start = await requester.getUint64(atom.offset + 24);
        } else {
          stream.elst_length = await requester.getUint32(atom.offset + 16);
          stream.elst_start = await requester.getUint32(atom.offset + 20);
        }
      } else if (edit_count) {
      }
    } else if (atom_name === "tkhd") {
      const version = await requester.getUint8(atom.offset + 8);
      stream.track_id = await requester.getUint32(atom.offset + (version === 1 ? 28 : 20));
    } else if (atom_name === "mdhd") {
      const version = await requester.getUint8(atom.offset + 8);
      stream.time_scale = await requester.getUint32(atom.offset + (version === 1 ? 28 : 20));
    } else if (atom_name === "mvhd") {
      const version = await requester.getUint8(atom.offset + 8);
      if (version === 1) {
        media_info.time_scale = await requester.getUint32(atom.offset + 28);
        media_info.duration = await requester.getUint64(atom.offset + 32);
      } else {
        media_info.time_scale = await requester.getUint32(atom.offset + 20);
        media_info.duration = await requester.getUint32(atom.offset + 24);
      }
    } else if (atom_name === "avc1" || atom_name === "hvc1") {
      stream.is_video = true;
      atoms = atoms.concat(await parseAtoms(requester, atom.offset + 86, offset, level + 1, media_info, stream));
    } else if (atom_name === "mp4a" || atom_name === ".mp3") {
      stream.is_audio = true;
      stream.channels = await requester.getUint16(atom.offset + 24);
      atoms = atoms.concat(await parseAtoms(requester, atom.offset + 36, offset, level + 1, media_info, stream));
    } else if (atom_name === "esds" && stream && stream.is_audio) {
      const t = await requester.getUint32(atom.offset + 12);
      if (t === 58753152) {
        const data = await requester.getUint16(atom.offset + 43);
        const object_type = data >>> 11 & 31;
        if (object_type >= 1 && object_type <= 4) {
          stream.aac_sample_rate = getAacSampleRate(data >>> 7 & 15);
          stream.aac_channels = getAacChannels(data >>> 3 & 15);
        }
      }
    } else if (atom_name === "stsd") {
      atoms = atoms.concat(await parseAtoms(requester, atom.offset + 16, offset, level + 1, media_info, stream));
    } else if (atom_name === "mdia" || atom_name === "minf" || atom_name === "moov" || atom_name === "stbl" || atom_name === "trak" || atom_name === "edts") {
      if (atom_name === "trak") {
        stream = {};
        media_info.streams.push(stream);
      }
      atoms = atoms.concat(await parseAtoms(requester, atom.offset + 8, offset, level + 1, media_info, stream));
      if (atom_name === "trak") {
        await parsePts(requester, stream);
        stream = void 0;
      } else if (atom_name === "moov") {
        return atoms;
      }
    }
  }
  return atoms;
}
async function parsePts(requester, stream) {
  var _a, _b;
  if (!stream.stts) {
    return;
  }
  stream.ptss = [];
  const delta_count = new Map();
  const sample_deltas = [];
  const stts_count = await requester.getUint32(stream.stts.offset + 12);
  await requester.requestRange(stream.stts.offset + 16, 8 * stts_count);
  for (let i = 0; i < stts_count; i++) {
    const sample_count = requester.getUint32sync(stream.stts.offset + 16 + i * 8);
    const sample_delta = requester.getInt32sync(stream.stts.offset + 20 + i * 8);
    for (let j = 0; j < sample_count; j++) {
      const n = delta_count.get(sample_delta) || 0;
      delta_count.set(sample_delta, n + 1);
      sample_deltas.push(sample_delta);
    }
  }
  let dts = 0;
  let dts_fps = 0;
  let dts_fps_count = 0;
  if (stream.ctts) {
    let sample_index = 0;
    const ctts_count = await requester.getUint32(stream.ctts.offset + 12);
    await requester.requestRange(stream.ctts.offset + 16, 8 * ctts_count);
    for (let i = 0; i < ctts_count; i++) {
      const sample_count = requester.getUint32sync(stream.ctts.offset + 16 + i * 8);
      const sample_offset = requester.getInt32sync(stream.ctts.offset + 20 + i * 8);
      for (let j = 0; j < sample_count; j++) {
        stream.ptss.push(dts + sample_offset);
        if (delta_count.get(sample_deltas[sample_index])) {
          dts_fps += sample_deltas[sample_index];
          dts_fps_count++;
        } else {
        }
        dts += sample_deltas[sample_index++];
      }
    }
  } else {
    for (let i = 0; i < sample_deltas.length; i++) {
      stream.ptss.push(dts);
      if (delta_count.get(sample_deltas[i])) {
        dts_fps += sample_deltas[i];
        dts_fps_count++;
      } else {
      }
      dts += sample_deltas[i];
    }
  }
  if (stream.is_video) {
    stream.fps = stream.time_scale / (dts_fps / dts_fps_count);
    if (delta_count.size !== 0) {
      stream.vfr = delta_count.size !== 1;
    }
  }
  stream.duration = dts;
  if (!stream.is_video) {
    if (stream.is_audio) {
      stream.first_pts = arrayMin(stream.ptss);
      stream.ts = [];
    }
    return;
  }
  let ts = [];
  for (let i = 0; i < sample_deltas.length; i++) {
    ts.push({
      dts: i,
      pts: stream.ptss[i],
      sts: null,
      delta: sample_deltas[i]
    });
  }
  ts = ts.sort((lhs, rhs) => {
    return lhs.pts - rhs.pts;
  });
  let dup = false;
  for (let i = 1; i < ts.length; ) {
    if (ts[i - 1].pts === ts[i].pts) {
      ts[i - 1].delta = Math.max(ts[i - 1].delta, ts[i].delta);
      ts.splice(i, 1);
      dup = true;
    } else {
      i++;
    }
  }
  if (dup) {
    console.warn("Duplicate PTS found. Frame accuracy can not be guaranteed.");
    stream.inaccurate = true;
  }
  stream.first_pts = (_b = (_a = ts[0]) == null ? void 0 : _a.pts) != null ? _b : NaN;
  stream.ts = ts;
}
export {
  RangeRequester,
  arrayMin,
  getMediaInfo
};
//# sourceMappingURL=index.esm.js.map
